import React from 'react';
import AviamentoQuntidadeStepTemplate, {
  AviamentoProps,
} from '../../../template/AviamentoQuntidadeStepTemplate';
import { createBackHandler } from '../../../template/utils';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import FaltaDeAviamento from './FaltaDeAviamento';
import FaltaDeAviamentoFinalStep from './FaltaDeAviamentoFinalStep';

const FaltaDeAviamentoQuantidadeStep: TipoDivergenciaComponent<AviamentoProps> = ({
  onSetStep,
  onBack,
  payload,
  onClose,
}) => {
  const backComponent = FaltaDeAviamento;
  const nextComponent = FaltaDeAviamentoFinalStep;

  const onBackHandler = createBackHandler(onBack, backComponent);
  return (
    <AviamentoQuntidadeStepTemplate
      nextStepComponent={nextComponent as TipoDivergenciaComponent}
      onClose={onClose}
      onSetStep={onSetStep}
      onBack={onBackHandler}
      payload={payload}
    ></AviamentoQuntidadeStepTemplate>
  );
};

export default FaltaDeAviamentoQuantidadeStep;
